import { gql } from 'urql';

export const GET_ANALYTICS_TRAITS = gql`
  query GetAnalyticsTraits {
    identity {
      user {
        email
        fullName
        id
        isAdmin
        isInvitedUser
        job
        lastSeenAt
        signature
      }
      account {
        createdAt
        flowsShown
        id
        isTrial
        isTrialExpired
        name
        stripePlanId
        stripeSubCreatedAt
        testPassword
        testUsername
        groupProfileIdentifier
        userProfileIdentifier
      }
    }
    trialStatus {
      expirationDate
      isExpired
      isWebInstalled
      lengthDays
    }
  }
`;

export const GET_ACCOUNT_TRAITS = gql`
  query GetAccountTraits {
    account {
      id
      tier
      createdAt
    }
  }
`;
